import {routes} from "./routes"
import store from "../store"

export const canAccessRoute = function (route) {

    return route.meta.permissions.every(canAccess);
};

const hasContextPermission = function (perm) {
    if(perm === "exists") {
        return store.getters.getContextUser !== null;
    }

    return store.getters.hasContextPermission(perm);
};

const hasMixedPerm = function (perm) {
    if(isContextPerm(perm)){
        // Context permission?
        return hasContextPermission(perm.substring(8));
    } else {
        // Regular permission
        return store.getters.hasPermission(perm);
    }
};

const isContextPerm = function (perm){
    return (perm.substring(0, 8) === "context_");
};

export const canAccess = function (exp)
{
    if(!Array.isArray(exp))
        return hasMixedPerm(exp);

    let op = exp[0];
    if(op === 'or')
        return hasAny(exp.slice(1));
    else if(op === 'not' && exp.length === 2)
        return !(canAccess(exp[1]));
    else
        return hasAll(exp);
};

const hasAny = function (list) {
    return list.some(canAccess);
};

const hasAll = function (list) {
    return (
        list.length > 0 &&
        list.every(canAccess)
    );
};

export const getMenuItems = function () {
    let filtered = [];
    let index = -1;
    for (let i = 0; i < routes.length; i++) {
        if (canAccessRoute(routes[i])) {
            let {submenu, ...route} = routes[i];
            filtered[++index] = route;

            if(submenu)
            {
                filtered[index].submenu = [];

                for(let x = 0; x < submenu.length; x++)
                {
                    if(canAccessRoute(submenu[x])) {
                        filtered[index].submenu.push(submenu[x]);
                    }
                }
            }
        }
    }

    return filtered
};


// WEBPACK FOOTER //
// ./src/router/functions.js